export const INDEX_GROUPS = [
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 7, label: '7' },
];

export const STATE_IN_GROUPS = ['WA', 'OR', 'NV', 'UT', ]